<!-- eslint-disable vue/no-v-html -->
<template>
  <CodeEmbedComponent
    v-bind="props"
    :class="{ 'inline-flex': true }"
  />
</template>

<script setup lang="ts">
import CodeEmbedComponent from './CodeEmbed.vue';
import type { CodeEmbed } from '~/sanity/types';
const props = defineProps<CodeEmbed>();
</script>

<style></style>
